import React, { useState, useContext } from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { LocaleContext } from '../../components/LocaleContext';
import { getPersistedMenuDisplayName, getPersistedMenuTabOpenFields } from './menuDisplayLabel';

function FavoriteMenu({ items, depth, props }) {
  const [, dispatch] = useContext(DatabaseContext);
  const { t } = useContext(LocaleContext);
  const [displayChildren, setDisplayChildren] = useState({});

  return (
    <ul className="pt-2 pb-4 space-y-1 text-sm bg-[#333]">
      {(items || []).map((item) => (
        <React.Fragment key={item.id ?? `${item.page || 'group'}-${item.name}`}>
          {item.favorites ? (
            <li className="rounded-sm ">
              <button
                type="button"
                className="flex items-start w-full min-w-0 p-2 gap-3 rounded-md group text-black hover:bg-[#555]"
                onClick={() => {
                  setDisplayChildren({
                    ...displayChildren,
                    [item.name]: !displayChildren[item.name],
                  });
                }}
                onContextMenu={(e) => {
                  props.setFavorite(item);
                  props.hideAll();
                  props.groupFav.current.show(e);
                }}
              >
                <span className="text-gray-100 flex-1 min-w-0 text-left ml-3 break-words [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] overflow-hidden">{item.name}</span>
                <svg sidebar-toggle-item="true" className="shrink-0 w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
              </button>
              {displayChildren[item.name] && item.favorites && (
                <FavoriteMenu items={item.favorites} depth={depth + 1} props={props} />
              )}
            </li>
          ) : (
            <li
              onContextMenu={(e) => {
                props.setFavorite(item);
                props.hideAll();
                props.fav.current.show(e);
              }}
            >
              <button
                onDoubleClick={() => {
                  const tabFields = getPersistedMenuTabOpenFields(item, t);
                  dispatch({
                    type: 'create_new_tab',
                    ...tabFields,
                    page: item.page,
                  });
                }}
                className="flex items-start w-full min-w-0 p-2 text-white transition duration-75 rounded-lg group hover:bg-[#555] pl-11"
              >
                <span className="flex-1 min-w-0 text-left break-words [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] overflow-hidden">
                  {getPersistedMenuDisplayName(item, t)}
                </span>
              </button>
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
}
export default FavoriteMenu;
